import { render, staticRenderFns } from "./CalloutBubble.vue?vue&type=template&id=515424b3&"
import script from "./CalloutBubble.vue?vue&type=script&lang=js&"
export * from "./CalloutBubble.vue?vue&type=script&lang=js&"
import style0 from "./CalloutBubble.vue?vue&type=style&index=0&id=515424b3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports